import { AlertTriangle } from 'lucide-react';

interface NotFoundMessageProps {
  title?: string;
  message?: string;
  onGoBack: () => void;
}

export default function NotFoundMessage({
  title = 'Not Found',
  message = 'The requested resource could not be loaded.',
  onGoBack,
}: NotFoundMessageProps) {
  return (
    <div className="max-w-2xl mx-auto mt-12 text-center">
      <div className="bg-white rounded-2xl shadow-xl border border-red-100 overflow-hidden p-12">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center text-red-600 mx-auto mb-6">
          <AlertTriangle className="w-10 h-10" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
        <p className="text-gray-500 mb-6">{message}</p>
        <button
          type="button"
          onClick={onGoBack}
          className="px-6 py-2.5 bg-emerald-800 text-white rounded-lg hover:bg-emerald-700 transition-colors"
        >
          Go Back
        </button>
      </div>
    </div>
  );
}
